export enum a11yKeys {
  Dyslexia = 'Dyslexia',
  HighContrast = 'HighContrast',
  FontSizeBase = 'FontSizeBase',
  FontSizeLg = 'FontSizeLg',
  FontSizeXl = 'FontSizeXl',
}
